export default __webpack_public_path__ + "static/media/MusicalIntruments_01.ccfe400a.png";